import { Pipe, PipeTransform } from '@angular/core'
@Pipe({
  name: 'waitCondition',
})
export class WaitForConditionPipe implements PipeTransform {
  transform(
    conditionFunction: () => boolean,
    maxAttempts,
    interval,
  ): Promise<void> {
    let attempts = 0
    return new Promise((resolve, reject) => {
      const checkCondition = () => {
        if (conditionFunction()) {
          resolve()
        } else if (attempts < maxAttempts) {
          attempts++
          // console.log('attempts ', attempts)
          setTimeout(checkCondition, interval)
        } else {
          reject(
            new Error('Condition not met within maximum number of attempts'),
          )
        }
      }
      checkCondition()
    })
  }
}
